// Commission Receipt Entry endpoints
export const commissionReceiptEndpoints = (builder) => ({
  getCommissionReceipt: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        sortField,
        sortOrder,
        ...rest
      } = args;

      const params = { pageNumber, pageSize };
      if (searchTerm !== null && searchTerm !== undefined) params.searchTerm = searchTerm;
      if (searchValue !== null && searchValue !== undefined) params.searchValue = searchValue;
      if (sortField !== null && sortField !== undefined) params.sortField = sortField;
      if (sortOrder !== null && sortOrder !== undefined) params.sortOrder = sortOrder;

      // forward other primitive params if present
      Object.keys(rest).forEach((k) => {
        const v = rest[k];
        if (v !== null && v !== undefined && (typeof v !== 'object' || Array.isArray(v))) {
          params[k] = v;
        }
      });

      return {
        url: '/life-Insurance/get-commission-receipt-entry',
        method: 'GET',
        params,
      };
    },
    providesTags: ['CommissionReceipt'],
  }),

  getCommissionReceiptById: builder.query({
    query: (id) => ({
      url: `/life-Insurance/get-commission-receipt-entry/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'CommissionReceipt', id }],
  }),

  saveCommissionReceipt: builder.mutation({
    query: (data) => ({
      url: '/life-Insurance/save-commission-receipt-entry',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['CommissionReceipt'],
  }),

  updateCommissionReceipt: builder.mutation({
    query: ({ data }) => ({
      url: `/life-Insurance/save-commission-receipt-entry`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'CommissionReceipt', id },
      'CommissionReceipt',
    ],
  }),

  deleteCommissionReceipt: builder.mutation({
    query: (id) => ({
      url: `/life-Insurance/delete-commission-receipt-entry/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['CommissionReceipt'],
  }),

  bulkDeleteCommissionReceipt: builder.mutation({
    query: (body) => ({
      url: '/life-Insurance/bulk-delete-commission-receipt-entry',
      method: 'DELETE',
      body,
    }),
    invalidatesTags: ['CommissionReceipt'],
  }),

  createCommissionWithDeposit: builder.mutation({
    query: (data) => ({
      url: '/life-insurance/create-commission-with-deposit',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['CommissionReceipt', 'PremiumDepositEntry', 'PendingPolicyImport'],
  }),

  // Pending Policy Import endpoints
  getPendingPolicyImportList: builder.query({
    query: ({ pageNumber = 1, pageSize = 10, searchTerm, searchValue }) => ({
      url: '/life-insurance/get-pending-policy-import',
      method: 'GET',
      params: { pageNumber, pageSize, searchTerm, searchValue },
    }),   
    providesTags: ['PendingPolicyImport'],
  }),

  getPendingPolicyImportById: builder.query({
    query: (id) => ({
      url: `/life-insurance/get-pending-policy-import/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'PendingPolicyImport', id }],
  }),

  deletePendingPolicyImport: builder.mutation({
    query: (id) => ({
      url: `/life-insurance/delete-pending-policy-import/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['PendingPolicyImport'],
  }),
});
  
